import CaregiverFormFlow from '../components/CaregiverFormFlow';

export default function Onboarding() {
  return <CaregiverFormFlow kind="onboarding" />;
}
